// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vuetify/dist/vuetify.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '../static/dealger.css'
// import '@mdi/font/css/materialdesignicons.css'
// import 'vue-material-design-icons/styles.css'
import 'typeface-roboto/index.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App'
import router from './router'
import store from './store'
import server from './api/server'

// import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  theme: {

    primary: '#80080a',
    secondary: '#606060',
    accent: '#DBBCBC',
    info: '#7F7F7F',
    // red: - default
    warning: '#FAAC59',
    success: '#088908'

    // primary.base: 'BA0C0F'
    // primary: '#80080a'
    // accent: '#FF888A',
    // accent: '#FFC6C7',

    // secondary.base: '#7F7F7F',
    // secondary: '#0C343D',
    // accent: '#ff5050'
    // accent: '#DBBCBC',
    // ,
    // warning: '#FAAC59',
    // success: '#088908'
  }
})

Vue.use(VueAxios, axios)
// your config here
// let config = {
//  toolbar: [
//    'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor'
//  ],
//  fontName: [
//    {val: 'arial black'},
//    {val: 'times new roman'},
//    {val: 'Courier New'}
//  ],
//  fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
//  uploadUrl: ''
// }

Vue.axios.defaults.baseURL = server.getBaseUrl()
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

Vue.config.productionTip = false
Vue.use(VueCordova)
Vue.use(VueHead)

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
      }
    ]
  }
})



// WEBPACK FOOTER //
// ./src/main.js